import React, { useState } from 'react';

interface PlanPageProps {
  // Add props as needed
}

const PlanPage: React.FC<PlanPageProps> = () => {
    const [selectedHelpPage, setSelectedHelpPage] = useState("shortcuts");

    function getContent(name: string): JSX.Element {
        switch (name) {
            case "shortcuts":
                return <Shortcuts />
            case "filters":
                return <Filters />
            case "sorting":
                return <Sorting />
            case "gantt":
                return <Gantt />
            case "progress":
                return <Progress />
            case "team":
                return <Team />
            case "addWP":
                return <AddWP />
            case "editWP":
                return <EditWP />
            case "addTasks":
                return <AddTasks />
            case "editTasks":
                return <EditTasks />
            case "deleteTasks":
                return <DeleteTasks />
            case "completeTasks":
                return <CompleteTasks />
            case "groupActions":
                return <GroupActions />
            case "movingTasks":
                return <MovingTasks />
            case "dependencies":
                return <Dependencies />
            default:
                return <Filters />
        }
    }

    return (
        <div className="flex flex-row w-full pt-4">
            <div className="flex flex-col min-w-[200px] mr-2">
                <ul className="text-center">
                    <li className={(selectedHelpPage == "shortcuts" ? "bg-table-subheader " : "bg-table-header ") + "rounded-tl-md p-2 bg-table-header hover:cursor-pointer "} onClick={() => setSelectedHelpPage("shortcuts")}>Keyboard Shortcuts</li>
                    <li className={(selectedHelpPage == "filters" ? "bg-table-subheader " : "bg-table-header ") + "p-2 bg-table-header hover:cursor-pointer "} onClick={() => setSelectedHelpPage("filters")}>Filters</li>
                    <li className={(selectedHelpPage == "sorting" ? "bg-table-subheader " : "bg-table-header ") + "p-2 hover:cursor-pointer "} onClick={() => setSelectedHelpPage("sorting")}>Sorting</li>
                    <li className={(selectedHelpPage == "gantt" ? "bg-table-subheader " : "bg-table-header ") + "p-2 hover:cursor-pointer "} onClick={() => setSelectedHelpPage("gantt")}>Gantt Chart</li>
                    <li className={(selectedHelpPage == "progress" ? "bg-table-subheader " : "bg-table-header ") + "p-2 hover:cursor-pointer "} onClick={() => setSelectedHelpPage("progress")}>Progess Chart</li>
                    <li className={(selectedHelpPage == "team" ? "bg-table-subheader " : "bg-table-header ") + "p-2 hover:cursor-pointer "} onClick={() => setSelectedHelpPage("team")}>Manage Team</li>
                    <li className={(selectedHelpPage == "addWP" ? "bg-table-subheader " : "bg-table-header ") + "p-2 hover:cursor-pointer "} onClick={() => setSelectedHelpPage("addWP")}>Adding Work Packages</li>
                    <li className={(selectedHelpPage == "editWP" ? "bg-table-subheader " : "bg-table-header ") + "p-2 hover:cursor-pointer "} onClick={() => setSelectedHelpPage("editWP")}>Edit Work Packages</li>
                    <li className={(selectedHelpPage == "addTasks" ? "bg-table-subheader " : "bg-table-header ") + "p-2 hover:cursor-pointer "} onClick={() => setSelectedHelpPage("addTasks")}>Adding Tasks</li>
                    <li className={(selectedHelpPage == "editTasks" ? "bg-table-subheader " : "bg-table-header ") + "p-2 hover:cursor-pointer "} onClick={() => setSelectedHelpPage("editTasks")}>Editing Tasks</li>
                    <li className={(selectedHelpPage == "deleteTasks" ? "bg-table-subheader " : "bg-table-header ") + "p-2 hover:cursor-pointer "} onClick={() => setSelectedHelpPage("deleteTasks")}>Deleting Tasks</li>
                    <li className={(selectedHelpPage == "completeTasks" ? "bg-table-subheader " : "bg-table-header ") + "p-2 hover:cursor-pointer "} onClick={() => setSelectedHelpPage("completeTasks")}>Completing Tasks</li>
                    <li className={(selectedHelpPage == "groupActions" ? "bg-table-subheader " : "bg-table-header ") + "p-2 hover:cursor-pointer "} onClick={() => setSelectedHelpPage("groupActions")}>Group Actions</li>
                    <li className={(selectedHelpPage == "movingTasks" ? "bg-table-subheader " : "bg-table-header ") + "p-2 hover:cursor-pointer "} onClick={() => setSelectedHelpPage("movingTasks")}>Moving Tasks</li>
                    <li className={(selectedHelpPage == "dependencies" ? "bg-table-subheader " : "bg-table-header ") + "rounded-bl-md p-2 hover:cursor-pointer "} onClick={() => setSelectedHelpPage("dependencies")}>Dependencies</li>
                </ul>
            </div>
            <div className="flex flex-col h-[800px] p-2 overflow-y-auto scrollbar">{getContent(selectedHelpPage)}</div>
        </div>
    );
};

export default PlanPage;

const Shortcuts: React.FC = () => {
    return (
        <>
            <h1 className="text-2xl font-bold mb-2">Keyboard Shortcuts</h1>
            <table className="table-auto border-collapse border border-slate-400">
                <thead>
                    <tr>
                        <th className="border border-slate-300 p-2">Shortcut</th>
                        <th className="border border-slate-300 p-2">Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td className="border border-slate-300 p-2">Ctrl + M</td>
                        <td className="border border-slate-300 p-2">Add Multiple Tasks</td>
                    </tr>
                    <tr>
                        <td className="border border-slate-300 p-2">Alt + M</td>
                        <td className="border border-slate-300 p-2">Toggle On/Off Multiselect mode</td>
                    </tr>
                    <tr>
                        <td className="border border-slate-300 p-2">Alt + I</td>
                        <td className="border border-slate-300 p-2">Indent Selected Tasks</td>
                    </tr>
                    <tr>
                        <td className="border border-slate-300 p-2">Alt + O</td>
                        <td className="border border-slate-300 p-2">Outdent Selected Tasks</td>
                    </tr>
                    <tr>
                        <td className="border border-slate-300 p-2">Alt + T</td>
                        <td className="border border-slate-300 p-2">Open Team Builder Dialog</td>
                    </tr>
                    <tr>
                        <td className="border border-slate-300 p-2">Alt + G</td>
                        <td className="border border-slate-300 p-2">Toggle On/Off the Gantt Chart</td>
                    </tr>
                    <tr>
                        <td className="border border-slate-300 p-2">Alt + P</td>
                        <td className="border border-slate-300 p-2">Toggle On/Off the Progress Chart</td>
                    </tr>
                    <tr>
                        <td className="border border-slate-300 p-2">Alt + E</td>
                        <td className="border border-slate-300 p-2">Open / Close the Edit Panel</td>
                    </tr>
                    <tr>
                        <td className="border border-slate-300 p-2">Alt + 'Plus Key'</td>
                        <td className="border border-slate-300 p-2">Add a new Task</td>
                    </tr>
                    <tr>
                        <td className="border border-slate-300 p-2">Alt + D</td>
                        <td className="border border-slate-300 p-2">Delete selected Task(s)</td>
                    </tr>
                    <tr>
                        <td className="border border-slate-300 p-2">Ctrl + 'Up Arrow'</td>
                        <td className="border border-slate-300 p-2">Move Task or Work Package Selection Up</td>
                    </tr>
                    <tr>
                        <td className="border border-slate-300 p-2">Ctrl + 'Down Arrow'</td>
                        <td className="border border-slate-300 p-2">Move Task or Work Package Selection Down</td>
                    </tr>
                    <tr>
                        <td className="border border-slate-300 p-2">Shift + 'Page Down'</td>
                        <td className="border border-slate-300 p-2">Switch 'Levels' from Project to Work Package, or from Work Package to Task</td>
                    </tr>
                    <tr>
                        <td className="border border-slate-300 p-2">Shift + 'Page Up'</td>
                        <td className="border border-slate-300 p-2">Switch 'Levels' from Task to Work Package, or from Work Package to Project</td>
                    </tr>
                    <tr>
                        <td className="border border-slate-300 p-2">Ctrl + B</td>
                        <td className="border border-slate-300 p-2">Hide / Show Sidebar</td>
                    </tr>
                    <tr>
                        <td className="border border-slate-300 p-2">Ctrl + J</td>
                        <td className="border border-slate-300 p-2">Open the 'Jump' menu to navigate quickly</td>
                    </tr>
                </tbody>
            </table>
        </>
    );
}

const Filters: React.FC = () => {
    return (
        <>
            <h1 className="text-2xl font-bold mb-2">Filters</h1>
            <div className="flex flex-row">
                <video width="960" height="720" controls>
                    <source src="/videos/help/plan/plan_filter_text.mp4" type="video/mp4" />
                </video>
                <div className="p-2">
                    <p>
                        Typing into the search box filters the tasks by name.
                    </p>
                </div>
            </div>
            <div className="flex flex-row mt-4">
                <video width="960" height="720" controls>
                    <source src="/videos/help/plan/plan_filter_deliverables.mp4" type="video/mp4" />
                </video>
                <div className="p-2">
                    <p>
                        Selecting the deliverables filter displays only deliverables. Filters can be combined.
                    </p>
                </div>
            </div>
            <div className="flex flex-row mt-4">
                <video width="960" height="720" controls>
                    <source src="/videos/help/plan/plan_milestone_filter_select_visible.mp4" type="video/mp4" />
                </video>
                <div className="p-2">
                    <p>
                        A good use of filters is to quickly select all tasks of a certain type. In this case all milestones.
                    </p>
                    <br />
                    <p>
                        Once you have filtered to only see tasks you want to select, hold the control key and click on the multiselect button.
                        This will select all visible tasks.
                    </p>
                </div>
            </div>
            <div className="flex flex-row mt-4">
                <video width="960" height="720" controls>
                    <source src="/videos/help/plan/plan_filter_display_on.mp4" type="video/mp4" />
                </video>
                <div className="p-2">
                    <p>
                        In the plan you have the option to choose to display a task on the Charter and / or the Status Report. This these filters offer a 
                        quick way to view which tasks you have selected for display.
                    </p>
                </div>
            </div>
            <div className="flex flex-row mt-4">
                <video width="960" height="720" controls>
                    <source src="/videos/help/plan/plan_filter_assigned_you.mp4" type="video/mp4" />
                </video>
                <div className="p-2">
                    <p>
                        This filter provides a quick way to see all tasks that are assigned to you
                    </p>
                </div>
            </div>
            <div className="flex flex-row mt-4">
                <video width="960" height="720" controls>
                    <source src="/videos/help/plan/plan_filter_unassigned.mp4" type="video/mp4" />
                </video>
                <div className="p-2">
                    <p>
                        This filter provides a quick way to see all tasks that have yet to be assigned
                    </p>
                </div>
            </div>
            <div className="flex flex-row mt-4">
                <video width="960" height="720" controls>
                    <source src="/videos/help/plan/plan_filter_dependencies.mp4" type="video/mp4" />
                </video>
                <div className="p-2">
                    <p>
                        To filter by dependencies, a task must be selected. When a task is selected and the filter is applied, only tasks related to the
                        selected task will be displayed. This includes any tasks that depend on the selected task, and any tasks the selected task depends on.
                    </p>
                </div>
            </div>
            <div className="flex flex-row mt-4">
                <video width="960" height="720" controls>
                    <source src="/videos/help/plan/plan_filter_selected.mp4" type="video/mp4" />
                </video>
                <div className="p-2">
                    <p>
                        To filter by selected, you must be in multiselect mode with atleast one task selected. This filter will then display only selected tasks.
                    </p>
                </div>
            </div>
        </>
    );
}

const Sorting: React.FC = () => {
    return (
        <>
            <h1 className="text-2xl font-bold mb-2">Sorting</h1>
            <div className="flex flex-row">
                <video width="960" height="720" controls>
                    <source src="/videos/help/plan/plan_sort_asc_desc.mp4" type="video/mp4" />
                </video>
                <div className="p-2">
                    <p>
                        Clicking on the column headers in a Work Package will toggle between sorting by ascending and descending. This adjusts the index
                        of the tasks and they are saved in that order.
                    </p>
                    <br />
                    <p>
                        Note: Only root tasks are effected by this sorting, subtasks are not adjusted
                    </p>
                </div>
            </div>
            <div className="flex flex-row mt-4">
                <video width="960" height="720" controls>
                    <source src="/videos/help/plan/plan_task_drag_reorder.mp4" type="video/mp4" />
                </video>
                <div className="p-2">
                    <p>
                        You can also drag tasks to reorder them. Click on the task bar and hold for a second until the cursor changes, then drag to the desired location and release.
                    </p>
                    <br />
                    <p>
                        Note: Only root tasks are effected by this sorting, subtasks are not adjusted and cannot be dragged
                    </p>
                </div>
            </div>
            <div className="flex flex-row mt-4">
                <video width="960" height="720" controls>
                    <source src="/videos/help/plan/plan_wp_drag_reorder.mp4" type="video/mp4" />
                </video>
                <div className="p-2">
                    <p>
                        You can also drag Work Packages to reorder them. Click on the Work Package bar and hold for a second until the cursor changes, then drag to the desired location and release.
                    </p>
                </div>
            </div>
        </>
    );
}

const Gantt: React.FC = () => {
    return (
        <>
            <h1 className="text-2xl font-bold mb-2">Gantt Chart</h1>
            <div className="flex flex-row items-start">
                <video width="960" height="720" controls>
                    <source src="/videos/help/plan/Plan_basic_gantt.mp4" type="video/mp4" />
                </video>
                <div className="p-2">
                    <p>
                        The gantt charts offers a visualisation of the timeline of your plan
                    </p>
                    <br />
                    <p>
                        Tasks and Subtasks can be hidden or displayed by expanding or collapsing the parent. All filter functionality is also still available
                        in gantt mode.
                    </p>
                    <br />
                    <p>
                        The control panel offers 3 sliders to control the 'Scale', 'Display Length', and 'View From'
                    </p>
                    <br />
                    <p>
                        The 'Scale' slider allows you to choose between day, week, month, or year scales
                    </p>
                    <br />
                    <p>
                        The 'Display Length' slider allows you to choose how many of your scale units to display
                    </p>
                    <br />
                    <p>
                        The 'View From' slider allows you to choose the start date of your gantt chart. Note, the 'View From' slider date range is from the
                        project start date to the last day of the project. If the whole of the project is already being displayed, you wont be able to scroll
                        further along (there's nothing to see).
                    </p>
                    <br />
                    <p>
                        Finally the 'Scale to Selected' button automatically sets the 3 sliders in order to show the selected Task / Tasks or Work Package if
                        no Tasks are selected, or the whole project if no Work Packages selected.
                    </p>
                </div>
            </div>
        </>
    );
}

const Team: React.FC = () => {
    return (
        <>
            <h1 className="text-2xl font-bold mb-2">Manage Team</h1>
            <div className="flex flex-row">
                <video width="960" height="720" controls>
                    <source src="/videos/help/plan/plan_manage_team.mp4" type="video/mp4" />
                </video>
                <div className="p-2">
                    <p>
                        You can manage your Team without leaving the Plan page by clicking on the 'Manage Team' button
                    </p>
                    <br />
                    <p>
                        If you open the plan page before you have selected a Team, the Team builder pop up will open automatically to give you the opportunity
                        to build your team before starting your plan. You can elect to continue without building a team by simply closing this window.
                        Without a team you will not be able to assign Tasks to a team member.
                    </p>
                </div>
            </div>
        </>
    );
}

const AddWP: React.FC = () => {
    return (
        <>
            <h1 className="text-2xl font-bold mb-2">Add Work Package</h1>
            <div className="flex flex-row">
                <video width="960" height="720" controls>
                    <source src="/videos/help/plan/plan_add_new_wp.mp4" type="video/mp4" />
                </video>
                <div className="p-2">
                    <p>
                        Click the plus symbol on the right hand side of the Project bar to add a new Work Package
                    </p>
                    <br />
                    <p>
                        The new Work Package will have one Task as default
                    </p>
                </div>
            </div>
        </>
    );
}

const EditWP: React.FC = () => {
    return (
        <>
            <h1 className="text-2xl font-bold mb-2">Edit Work Package</h1>
            <div className="flex flex-row">
                <video width="960" height="720" controls>
                    <source src="/videos/help/plan/plan_add_new_wp.mp4" type="video/mp4" />
                </video>
                <div className="p-2">
                    <p>
                        You can edit the name of the Work Package inline by clicking directly on the name of the selected Work Package 
                    </p>
                </div>
            </div>
            <div className="flex flex-row">
                <video width="960" height="720" controls>
                    <source src="/videos/help/plan/plan_update_wp_startdate.mp4" type="video/mp4" />
                </video>
                <div className="p-2">
                    <p>
                        With the Work Package selected, click on the 'Pencil' Icon to open the edit panel.
                    </p>
                    <br />
                    <p>
                        In the panel you can update the name, the owner of the Work Package, and set the start date.
                    </p>
                    <br />
                    <p>
                        Updating the start date if the Work Package will update the start dates of any tasks that would start before the selected date
                        and any dependent tasks
                    </p>
                </div>
            </div>
        </>
    );
}

const AddTasks: React.FC = () => {
    return (
        <>
            <h1 className="text-2xl font-bold mb-2">Add Tasks</h1>
            <div className="flex flex-row">
                <video width="960" height="720" controls>
                    <source src="/videos/help/plan/Plan_add_tasks_and_subtasks.mp4" type="video/mp4" />
                </video>
                <div className="p-2">
                    <p>
                        Add Tasks by clicking on the plus symbol on the right hand side of the Work Package bar.
                    </p>
                    <br />
                    <p>
                        Add Subtasks by clicking on the plus symbol on a task bar.
                    </p>
                </div>
            </div>
        </>
    );
}

const EditTasks: React.FC = () => {
    return (
        <>
            <h1 className="text-2xl font-bold mb-2">Edit Tasks</h1>
            <div className="flex flex-row">
                <video width="960" height="720" controls>
                    <source src="/videos/help/plan/Plan_add_tasks_and_subtasks.mp4" type="video/mp4" />
                </video>
                <div className="p-2">
                    <p>
                        You can edit Tasks inline by clicking on the field you'd like to edit of the selected task. 
                    </p>
                    <br />
                    <p>
                        Add Subtasks by clicking on the plus symbol on a task bar.
                    </p>
                </div>
            </div>
            <div className="flex flex-row">
                <video width="960" height="720" controls>
                    <source src="/videos/help/plan/plan_set_task_startdate.mp4" type="video/mp4" />
                </video>
                <div className="p-2">
                    <p>
                        Changing the tasks start date will update any dependent tasks start dates as task is moved forward maintaining its duration.
                    </p>
                    <br />
                    <p>
                        Work Package dates are driven by the tasks they contain, so will also update to reflect the changes
                    </p>
                </div>
            </div>
            <div className="flex flex-row">
                <video width="960" height="720" controls>
                    <source src="/videos/help/plan/plan_set_task_enddate.mp4" type="video/mp4" />
                </video>
                <div className="p-2">
                    <p>
                        Changing the tasks end date will update any dependent tasks start dates and update its duration.
                    </p>
                    <br />
                    <p>
                        Work Package dates are driven by the tasks they contain, so will also update to reflect the changes
                    </p>
                </div>
            </div>
            <div className="flex flex-row">
                <video width="960" height="720" controls>
                    <source src="/videos/help/plan/plan_duration_dependencies.mp4" type="video/mp4" />
                </video>
                <div className="p-2">
                    <p>
                        Changing the tasks duration will update its end date and update any dependent tasks start dates.
                    </p>
                    <br />
                    <p>
                        Work Package dates are driven by the tasks they contain, so will also update to reflect the changes
                    </p>
                </div>
            </div>
        </>
    );
}

const DeleteTasks: React.FC = () => {
    return (
        <>
            <h1 className="text-2xl font-bold mb-2">Delete Tasks</h1>
            <div className="flex flex-row">
                <video width="960" height="720" controls>
                    <source src="/videos/help/plan/plan_delete_task.mp4" type="video/mp4" />
                </video>
                <div className="p-2">
                    <p>
                        Delete Tasks by clicking on the 'Pencil' icon to open the edit panel, then click the 'Trash Can' symbol on the right
                        hand side of the title bar.
                    </p>
                </div>
            </div>
            <div className="flex flex-row">
                <video width="960" height="720" controls>
                    <source src="/videos/help/plan/plan_group_delete_tasks.mp4" type="video/mp4" />
                </video>
                <div className="p-2">
                    <p>
                        You can also delete multiple tasks at once by selecting multiple tasks, either by selecting a task and then control clicking on another task to select all tasks between the two,
                        or by selecting multiselect from the control panel at the top. 
                    </p>
                    <br />
                    <p>
                        Once you have selected the tasks you'd like to delete, open the edit panel by clicking the 'Pencil' icon, then click the 'Trash Can' symbol on the right
                        hand side of the title bar.
                    </p>
                    <br />
                    <p>
                        If any of the selected Tasks can't be deleted for any reason, then the action will be cancelled and none of the Tasks will be deleted.
                    </p>
                </div>
            </div>
        </>
    );
}

const CompleteTasks: React.FC = () => {
    return (
        <>
            <h1 className="text-2xl font-bold mb-2">Complete Tasks</h1>
            <div className="flex flex-row">
                <video width="960" height="720" controls>
                    <source src="/videos/help/plan/plan_completing_tasks.mp4" type="video/mp4" />
                </video>
                <div className="p-2">
                    <p>
                        You can mark Tasks as complete inline by clicking on the 'Check' box on the left hand side of the bar.
                    </p>
                    <br />
                    <p>
                        If the Task can't be completed for some reason, a message will be displayed in the Taskbar on the bottom right'
                    </p>
                    <br />
                    <p>
                        Tasks can also be completed using the edit panel, with the added feature of being able to edit the completed date
                    </p>
                </div>
            </div>
            <div className="flex flex-row">
                <video width="960" height="720" controls>
                    <source src="/videos/help/plan/plan_group_complete_tasks.mp4" type="video/mp4" />
                </video>
                <div className="p-2">
                    <p>
                        You can also complete multiple tasks at once by selecting multiple tasks, either by selecting a task and then control clicking on another task to select all tasks between the two,
                        or by selecting multiselect from the control panel at the top.
                    </p>
                    <br />
                    <p>
                        Once you have selected the tasks you'd like to complete, open the edit panel by clicking the 'Pencil' icon, then click the 'Tick' symbol on the right
                        hand side of the title bar.
                    </p>
                    <br />
                    <p>
                        If any of the selected Tasks can't be completed for any reason, then the action will be cancelled and none of the Tasks will be completed.
                    </p>
                </div>
            </div>
        </>
    );
}

const GroupActions: React.FC = () => {
    return (
        <>
            <h1 className="text-2xl font-bold mb-2">Group Actions</h1>
            <div className="flex flex-row items-start">
                <video width="960" height="720" controls>
                    <source src="/videos/help/plan/plan_add_multiple_tasks_group_edit.mp4" type="video/mp4" />
                </video>
                <div className="p-2">
                    <p>
                        Add Multiple Tasks by clicking on the 'Add Multiple Tasks' Button. This button is only enabled if either a Work Package or a task is selected
                    </p>
                    <br />
                    <p>
                        If a Task is selected the new Tasks will be added as Subtasks of the selected Task, otherwise the Tasks will be added to the Work Package
                    </p>
                    <br />
                    <p>
                        Once the Tasks are added, you will be asked if you would like to name the Tasks now. If you Agree you will be prompted to input a name for each task in succession.
                        As you can simple type a name, press enter and type the next name, this is quicker than naming the tasks later, assuming you know what you want to name them in advance.
                    </p>
                    <br />
                    <p>
                        Once you have named the Tasks or elected not to, the new Tasks will be selected. You can then open the edit panel by clicking on the 'Pencil' Icon.
                        Here you can perform group actions. In this example we assign the new Tasks to a user and set them as Deliverables.
                    </p>
                </div>
            </div>
            <div className="flex flex-row">
                <video width="960" height="720" controls>
                    <source src="/videos/help/plan/plan_ctrl_click_multiselect.mp4" type="video/mp4" />
                </video>
                <div className="p-2">
                    <p>
                        A useful and quick way to select multiple Tasks is to select a Task and the hold the Control key and select another Task. This will
                        automatically enable multiselect mode, selecting both Tasks and all Tasks in between (including Subtasks)
                    </p>
                </div>
            </div>
            <div className="flex flex-row">
                <video width="960" height="720" controls>
                    <source src="/videos/help/plan/plan_group_edit.mp4" type="video/mp4" />
                </video>
                <div className="p-2">
                    <p>
                        Enable multi select mode by clicking on the 'Multi Select' button. You can then select mulitple Tasks to edit as a group.
                    </p>
                    <br />
                    <p>
                        In this example we set the selected Tasks to be displayed on the Status Report
                    </p>
                </div>
            </div>
            <div className="flex flex-row">
                <video width="960" height="720" controls>
                    <source src="/videos/help/plan/plan_group_complete_tasks.mp4" type="video/mp4" />
                </video>
                <div className="p-2">
                    <p>
                        Select multiple tasks using the multi select feature, then open the edit panel. In the title bar of the group edit panel, you have
                        the option to complete the selected Tasks by clicking on the 'Tick'
                    </p>
                    <br />
                    <p>
                        If any of the selected Tasks can't be completed for any reason, then the action will be cancelled an none of the Tasks will be completed.
                    </p>
                </div>
            </div>
            <div className="flex flex-row">
                <video width="960" height="720" controls>
                    <source src="/videos/help/plan/plan_group_delete_tasks.mp4" type="video/mp4" />
                </video>
                <div className="p-2">
                    <p>
                        Select multiple tasks using the multi select feature, then open the edit panel. In the title bar of the group edit panel, you have
                        the option to delete the selected Tasks by clicking on the 'Trash Can'
                    </p>
                    <br />
                    <p>
                        If any of the selected Tasks can't be deleted for any reason, then the action will be cancelled and none of the Tasks will be deleted.
                    </p>
                </div>
            </div>
        </>
    );
}

const MovingTasks: React.FC = () => {
    return (
        <>
            <h1 className="text-2xl font-bold mb-2">Moving Tasks</h1>
            <div className="flex flex-row">
                <video width="960" height="720" controls>
                    <source src="/videos/help/plan/plan_move_tasks_to_wp.mp4" type="video/mp4" />
                </video>
                <div className="p-2">
                    <p>
                        Enable the multi select feature and select one or more tasks to move
                    </p>
                    <br />
                    <p>
                        Open the group edit menu and enable the 'Work Package' option by clicking the related check box. Select the Work Package you would like to 
                        move the selected Tasks to from the drop down, and click the 'Update Tasks' button.
                    </p>
                    <br />
                    <p>
                        This feature can be used to seperate Subtasks from Parent Tasks and put them in a Work Package as Root Tasks as in this example, or to move
                        multiple Tasks between Work Packages
                    </p>
                </div>
            </div>
            <div className="flex flex-row">
                <video width="960" height="720" controls>
                    <source src="/videos/help/plan/plan_drag_drop_task.mp4" type="video/mp4" />
                </video>
                <div className="p-2">
                    <p>
                        If you only need to move a single Task (and its Subtasks) to another Work Package, you can simply drag and drop the Task into the new Work Package.
                        Click on the Task bar and hold for a second until the cursor changes, then drag to the desired Work Package and release.
                    </p>
                    <br />
                    <p>
                        Note: Only Root Tasks can be moved this way
                    </p>
                </div>
            </div>
            <div className="flex flex-row">
                <video width="960" height="720" controls>
                    <source src="/videos/help/plan/plan_set_tasks_as_subtasks.mp4" type="video/mp4" />
                </video>
                <div className="p-2">
                    <p>
                        Enable the multi select feature and select one or more tasks to move
                    </p>
                    <br />
                    <p>
                        Open the edit panel and make any changes you need to make. To move the Tasks to be Subtasks of another Task, you need to open the second Tab of the
                        edit panel and select 'Set selected as subtasks of highlighted'.
                    </p>
                    <br />
                    <p>
                        Hold the control key and use the up and down arrow keys to select a task to be the 'Parent Task'. The highlighted Task is indicated by the white border.
                    </p>
                    <br />
                    <p>
                        You can also hold the alt key and click on a Task to highlight it
                    </p>
                    <br />
                    <p>
                        Once you have selected the 'Parent Task', click on the 'Update Tasks' button.
                    </p>
                </div>
            </div>
        </>
    );
}

const Progress: React.FC = () => {
    return (
        <>
            <h1 className="text-2xl font-bold mb-2">Progress Chart</h1>
            <div className="flex flex-row">
                <video width="960" height="720" controls>
                    <source src="/videos/help/plan/plan_wp_progress_chart.mp4" type="video/mp4" />
                </video>
                <div className="p-2">
                    <p>
                        For a quick visual representation of the progress of your project, click on the 'Show Progress Chart' button.
                        Each Work Package bar as Well as the Project bar will then show a progress bar, indicating the planned progress vs the actual progress.
                    </p>
                    <br />
                    <p>
                        Note: Only 'Root Tasks' are used to measure progress
                    </p>
                </div>
            </div>
        </>
    );
}

const Dependencies: React.FC = () => {
    return (
        <>
            <h1 className="text-2xl font-bold mb-2">Dependencies</h1>
            <div className="flex flex-row">
                <video width="960" height="720" controls>
                    <source src="/videos/help/plan/Plan_multiadd_dependencies_cascade.mp4" type="video/mp4" />
                </video>
                <div className="p-2">
                    <p>
                        The Quickest way to set a series of Tasks as dependent on the previous Task, is to use the 'Cascade dependencies' option under 'Set Dependencies'
                        in the group edit panel.
                    </p>
                    <br />
                    <p>
                        Note: Task dependencies will be cascaded in the order they are selected
                    </p>
                </div>
            </div>
        </>
    );
}